import { Button, Card, Col } from "antd";
import { PlusIcon } from "../../../../atoms/CustomIcons";

export default function RightSideBar() {
  return (
    <Col flex="360px">
      <Card className="right_inner">
        <h6> General details </h6>

        <div className="widgetCard" style={{ marginBottom: "24px" }}>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle">Account manager:</h6>
            <h6 className="miniDetail">
              <img
                src="/images/potential-deals/avatar.png"
                alt=""
                style={{
                  borderRadius: "100px",
                  width: "20px",
                  height: "20px",
                }}
              />
              Jack M.
            </h6>
          </div>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle">Production manager:</h6>
            <h6 className="miniDetail">
              <img
                src="/images/potential-deals/avatar.png"
                alt=""
                style={{
                  borderRadius: "100px",
                  width: "20px",
                  height: "20px",
                }}
              />
              Mary S.
            </h6>
          </div>
        </div>

        <div className="widgetCard">
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle">Crew:</h6>
            <h6 className="miniDetail">LM-1 (Carlos E.)</h6>
          </div>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle">Type of sale</h6>
            <h6 className="miniDetail">Base contract</h6>
          </div>
        </div>
      </Card>
      <Card className="right_inner">
        <h6> Contract terms </h6>
        <div className="widgetCard">
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Start date </h6>
            <h6 className="miniDetail"> Jan 20, 2025 </h6>
          </div>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> End date </h6>
            <h6 className="miniDetail"> Jan 20, 2026 </h6>
          </div>
        </div>

        <div className="widgetCard">
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Renewable </h6>
            <h6 className="miniDetail"> Yes </h6>
          </div>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Pricing model </h6>
            <h6 className="miniDetail"> Fixed price </h6>
          </div>
        </div>

        <div className="widgetCard">
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Billing </h6>
            <h6 className="miniDetail"> Monthly </h6>
          </div>
          <div style={{ width: "50%" }}>
            <h6 className="miniTitle"> Net terms </h6>
            <h6 className="miniDetail"> Due upon receipt </h6>
          </div>
        </div>
      </Card>

      <Card className="right_inner">
        <h6> Documents </h6>
        <div className="emptyBox">
          <img
            src="/images/empty-icons/no-archived.svg"
            alt=""
            style={{ width: "70px", height: "70px" }}
          />
          <Button className="outlined-btn" style={{ marginBottom: "47px" }}>
            <PlusIcon /> Add document
          </Button>
        </div>
      </Card>
    </Col>
  );
}
